export const serverUrl = ""
//export const serverUrl = "http://127.0.0.1:5000"
